import { render, staticRenderFns } from "./EventsEventDetails.vue?vue&type=template&id=015ab594&scoped=true&"
import script from "./EventsEventDetails.vue?vue&type=script&lang=ts&"
export * from "./EventsEventDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015ab594",
  null
  
)

export default component.exports